import { ThunkResult } from '../../../stores/types';
import formatErrorResponseV2 from '../../../utilities/format-error-response-v2';
import ActionTypes from '../constants/action-types';

export default function fetchLabelErrors(
  organizationId: string,
  orderNumber: string,
  submittedAt: string | undefined,
): ThunkResult<Promise<void>> {
  return function labelErrorsEffects(dispatch, getState, extra): Promise<void> {
    dispatch({
      type: ActionTypes.LABEL_ERRORS_REQUEST,
    });

    return extra.apiInternal(getState()).labelRequestResults.get({
      organization_id: [organizationId],
      order_number: [orderNumber],
      errors_only: true,
      created_at_from: submittedAt,
      created_at_to: new Date().toISOString(),
    }).then((response) => {
      if (response.ok) {
        dispatch({
          type: ActionTypes.LABEL_ERRORS_SUCCESS,
          payload: response.body,
        });
        return;
      }

      dispatch({
        type: ActionTypes.LABEL_ERRORS_FAILURE,
        payload: formatErrorResponseV2(response),
        error: true,
      });
    }).catch((e: unknown) => {
      dispatch({
        type: ActionTypes.LABEL_ERRORS_FAILURE,
        payload: {
          messages: [{
            message: e instanceof Error ? e.message : 'Unknown error',
          }],
        },
        error: true,
      });
    });
  };
}
